import { render, staticRenderFns } from "./relic-detail-plain.vue?vue&type=template&id=53db2c1b"
import script from "./relic-detail-plain.vue?vue&type=script&lang=js"
export * from "./relic-detail-plain.vue?vue&type=script&lang=js"
import style0 from "./relic-detail-plain.vue?vue&type=style&index=0&id=53db2c1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports